module.exports = __webpack_public_path__ + "img/Menu-08.9a893707.png";